import { Navigate, useSearchParams } from 'react-router';

import { TokenTypeCode } from '@/services/types';
import { ServiceErrorCode } from '@/services/utils/service-error';
import { decodeJwt } from '@/utils/jwt-utils';

import { VerifyAccount } from './verify-account-section';

export default function Verify() {
  const [searchParams] = useSearchParams();

  const token = searchParams.get('token') ?? '';
  const email = searchParams.get('email') ?? '';

  if (!token || !email) {
    return <Navigate to="/login" replace />;
  }

  const decoded = decodeJwt<{ verifyToken: string }>(token);
  if (!decoded?.verifyToken) {
    const params = new URLSearchParams({
      token,
      email,
      type: TokenTypeCode.VER_ACC,
      errorCode: ServiceErrorCode.InvalidToken,
    }).toString();
    return <Navigate to={`/verify/error?${params}`} replace />;
  }

  return <VerifyAccount email={email} />;
}
